
import React, { useState, useEffect, useContext } from "react";
import "./notificationSetting.css";
import { AuthContext } from "../../context/AuthContext";
import {
  getUserDetails,
  getDirectorDetails,
  getProducerDetails,
  getCrewDetails,
} from "../../api/axios";
import EditEmail from "./EditEmail";

const EmailNotifications = () => {
  const [userDetails, setUserDetails] = useState(null);
  const [isEnabled, setIsEnabled] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const { role, token, userId } = useContext(AuthContext);
  const userMainDetails = userDetails?.registerResult || {};
  const toggleSwitch = () => {
    setIsEnabled(!isEnabled);
  };

  const GetUserDetails = async (id, role) => {
    try {
      let data;
      switch (role) {
        case "actor":
          data = await getUserDetails(id);
          break;
        case "director":
          data = await getDirectorDetails(id);
          break;
        case "producer":
          data = await getProducerDetails(id);
          break;
        case "crew":
          data = await getCrewDetails(id);
          break;
        default:
          console.error("Unknown role:", role);
          return;
      }

      if (data.success) {
        setUserDetails(data.user);
        // console.log("UserData: ", data.user);
      }
    } catch (error) {
      // console.log("Error fetching user data", error);
    }
  };

  useEffect(() => {
    if (token && userId && role) {
      GetUserDetails(userId, role);
    }
  }, [token, userId, role]);

  const handleEditClick = () => {
    setIsEditing(true);
  };


  const handleBackClick = () => {
    setIsEditing(false);

  };

  if (isEditing) {
    return (

      <EditEmail
          userDetails={userDetails}
          GetUserDetails={GetUserDetails}
          userId={userId}
          handleBackClick={handleBackClick}
      />

    );
  }
  return (
    <div className="email-notification-container">
      <h2 className="email-title">Email Notifications</h2>
      <div className="notification-card">
        <div className="toggle-row">
          <span className="toggle-label">
            <strong>Allow email notifications</strong> | {userMainDetails.email}
          </span>
          <div
            className={`toggle-switch ${isEnabled ? "enabled" : ""}`}
            onClick={toggleSwitch}
          >
            <div className="toggle-thumb"></div>
          </div>
        </div>
        <hr />
        <div className="notification-message">
          {isEnabled ? (
           
            <span className="text">
              <p>
              Here's where you can easily manage your email subscription to ensure
              you stay informed with our latest news and updates. <br /> Please note, you
              will continue to receive essential service emails, but don't worry —
              they're a rare breed, so your inbox will remain nice and tidy.
            </p>
            </span>
          ) : (
            <span className="text">
              <p className="error-text">
              You have opted out of receiving all email notifications. <br />
              However, you will continue receiving service emails, e.g., payment
              notifications, etc.
            </p>
            </span>
          )}
        </div>
        <hr />
        <button className="edit-button" onClick={handleEditClick}>
          Edit email
        </button>
      </div>
    </div>
  );
};

export default EmailNotifications;
